import { css } from '@emotion/core'

export const styles = {
  button: css`
    width: 200px;
    height: 36px;

    padding-top: 2px;
    border-radius: 5px;

    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
    font-family: 'Open Sans', sans-serif;

    cursor: pointer;
    border: none;

    &:disabled {
      opacity: 0.75;
    }

    &:focus {
      outline: none;
    }

    &:active {
      box-shadow: 0 0 0 3px rgba(58, 137, 196, 0.5);
    }
  `,

  colors: {
    default: css`
      background: rgb(58, 137, 196);
      color: white;
    `,

    info: css`
      color: rgb(58, 137, 196);
      background: rgba(58, 137, 196, 0.06);
      box-shadow: rgba(15, 15, 15, 0.1) 0px 1px 2px,
        rgba(58, 137, 196, 0.3) 0px 0px 0px 1px inset;
    `,

    danger: css`
      color: rgb(235, 87, 87);
      background: rgba(235, 87, 87, 0.06);
      box-shadow: rgba(15, 15, 15, 0.1) 0px 1px 2px,
        rgba(235, 87, 87, 0.3) 0px 0px 0px 1px inset;
    `,
  },
}
